                                                                                                                    import React, { HTMLProps, memo } from 'react';
import Link from 'next/link';
interface IProps extends HTMLProps<HTMLElement> {
    to: string;
    title?: string;
    as?: string;
    newTab?: boolean;
    alt?: string;
    onClick?: (evt: any) => any;
}

export const RouterLink = React.forwardRef((props: IProps, ref: any) => {
    const {
        to,
        title = '',
        className = '',
        children,
        newTab = false,
        style = {},
        onClick,
    } = props;
    if (!to) {
        return (
            <div
                className={className}
                style={style}
                onClick={onClick}
                ref={ref}
            >
                {children}
            </div>
        );
    }

    return (
        <Link passHref as={to} href={to}>
            <a
                ref={ref}
                style={style}
                className={className}
                title={title}
                onClick={onClick}
                target={newTab ? '_blank' : undefined}
                rel={newTab ? 'noopener noreferrer' : undefined}
            >
                {children}
            </a>
        </Link>
    );
});
export default memo(RouterLink);
